import React, { useEffect, useState, useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import MainLayout from "layouts/Main";
import { Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "hooks";
import {
  selectProductionForecastGroup,
  selectProductionParks,
} from "store/selectors";
import {
  fetchAllProductionPark,
  fetchProductionForecastGroup,
} from "store/appSlice";
import Header from "./Header";
import ForecastFilters from "./ForecastFilters";
import ForecastActions from "./ForecastActions";
import ProductionForecastData from "./ProductionForecastData";

const ProductionForecastGroupView = () => {
  const [snackbar, setSnackbar] = useState(null);
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const productionParkIdsParam = searchParams.get("productionParkIds");
  const { id } = useParams();
  const forecastGroup = useAppSelector(selectProductionForecastGroup);
  const productionParks = useAppSelector(selectProductionParks);
  const [filters, setFilters] = useState({
    productionParkType: "",
    clientIds: [],
    productionParkIds: productionParkIdsParam
      ? productionParkIdsParam.split(",").map((x) => Number(x))
      : [],
    priceArea: "",
  });

  useEffect(() => {
    if (id) {
      dispatch(fetchProductionForecastGroup(Number(id), filters));
    }
    dispatch(fetchAllProductionPark(0, 1000));
  }, [dispatch, id]);

  const snackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbar(null);
  };

  const parks = useMemo(
    () =>
      productionParks?.content?.map((park) => ({
        title: park.name,
        value: park.id,
      })) || [],
    [productionParks],
  );

  return (
    <MainLayout
      snackbar={{
        open: snackbar,
        handleClose: snackbarClose,
        type: snackbar?.type,
        message: snackbar?.message,
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
      >
        <Header forecastGroup={forecastGroup} />
        <ForecastActions
          createdAt={forecastGroup?.createdAt}
          groupId={Number(id)}
          filters={filters}
          setSnackbar={setSnackbar}
        />
      </Box>
      {parks.length > 0 && (
        <ForecastFilters
          filters={filters}
          setFilters={setFilters}
          parks={parks || []}
          groupId={Number(id)}
        />
      )}
      <ProductionForecastData
        setSnackbar={setSnackbar}
        forecastGroup={forecastGroup}
        productionParks={productionParks}
        filters={filters}
      />
    </MainLayout>
  );
};

export default ProductionForecastGroupView;
